import React from "react";
import { motion } from "framer-motion";
import CarList from "../CarList/CarList";

const Categories = () => {
  return (
    <section className="py-10">
      <div className="items-center mx-auto container">
        <motion.h3 
          className="text-3xl text-center font-medium mb-4 w-full lg:w-1/2 mx-auto Aleo tracking-wide px-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Discover Our Wide Range of Vehicles <br /> at the Lowest Prices for{" "}<b>Rent a Car in Mykonos</b>
        </motion.h3>
        <motion.hr 
          className="w-40 mb-4 mx-auto border-2 border-red-400"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
        <motion.p 
          className="text-center text-sm text-gray-400 mb-6 w-full lg:w-1/2 mx-auto Aleo tracking-wide px-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <b>Mykonos Car Rentals</b> gives you multiple options to choose from a
          Wide Selection of Automatic and Manual Transmission Vehicles.
          Availability may vary based on the supplier and <b>car rental</b>{" "}
          location in <b>Mykonos</b>.
        </motion.p>
      </div>
      <motion.div 
        className="mx-auto container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <CarList />
      </motion.div>
    </section>
  );
};

export default Categories;
